import React from "react";
import { reduxForm, formValueSelector } from "redux-form";
import { Field, FieldArray } from "redux-form";
import { FormField } from "pickups-ui-library";
import { Button, FormGroup, Label, Alert } from "reactstrap";
import { formatPhone } from "../../../utils/helpers";
import { Link } from "react-router-dom";
import LoginLayout from "../../../containers/Register";
import Tracking from "../../../utils/tracking";

const ExistingAccount = (props) => {
  return (
    <div>
      <Alert color={"warning"}>
        There is an existing account associated with the phone number you
        entered
      </Alert>
      <div className={"box p-4"}>
        <h3>{formatPhone(props.phoneNumber)}</h3> The phone number you entered
        has been registered with an account. If you don't log in this pickup
        will not be associated with the account and will not appear in your
        donor dashboard.
        <div className={"form-controls"}>
          <div style={{ flex: 1 }}>
            <a
              style={{
                margin: "0 20px 0 0",
                color: "#898989",
                cursor: "pointer",
              }}
              onClick={props.previousStep}
            >
              Back
            </a>
            <Button
              type="submit"
              onClick={() => {
                Tracking.track("Step 5: Chose Continue as Guest");
                props.addDonor();
              }}
            >
              Continue as Guest
            </Button>{" "}
            <Button
              type="submit"
              onClick={() => {
                Tracking.track("Step 5: User Chose Login");
                // pushing location state to the login component, fromPublicForm
                // we are using this location state to tell the private form that is will not be a "normal" flow
                props.history.push(`/login`, { fromPublicForm: true });
              }}
            >
              Login
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default reduxForm({ form: "publicLoginForm" })(ExistingAccount);
